import { render, staticRenderFns } from "./MedicFrecuentes.vue?vue&type=template&id=bffb34ea&scoped=true"
import script from "./MedicFrecuentes.vue?vue&type=script&lang=js"
export * from "./MedicFrecuentes.vue?vue&type=script&lang=js"
import style0 from "./MedicFrecuentes.vue?vue&type=style&index=0&id=bffb34ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffb34ea",
  null
  
)

export default component.exports